export enum NotificationMinutesEnum {
        OneMinute = 2113,
        FiveMinute = 2114,
        TenMinute = 2115,
        FifteenMinute = 2116,
        TwentyMinute = 2117,
        ThirtyMinute = 2118,
        SixtyMinute = 2119,
}
